import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { UserFacadeService } from 'src/app/facades/user/user-facade.service';
import { FeedbackSnackbarService } from 'src/app/core/utilities/feedback-snackbar/feedback-snackbar.service';
import { StorageService } from 'src/app/core/store/storage/storage.service';
import { AuthFacadeService } from 'src/app/facades/auth/auth-facade.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit {
  userId: number;
  value: any;
  deleteOption: string = 'immediate';
  showConfirm: boolean = false;
  isDeleted: boolean;
  cancelUseId: any;
  gracePeriod: boolean;
  subscriptionExpired: boolean;
  isTrialPeriod: boolean;
  subEndDate: any;
  constructor(
    private bottom: MatBottomSheet,
    private bottomSheet: MatBottomSheetRef<DeleteAccountComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private storageService: StorageService,
    private userFacadeService: UserFacadeService,
    private snackBar: FeedbackSnackbarService,
    private authFacadeService: AuthFacadeService,
    private router: Router,
    private dialog: MatDialog,
  ) { 
    this.value = data?.value;
    this.deleteOption = data?.deleteOption || 'immediate';
    this.getStylistDetails()
  }

  ngOnInit(): void {
  }

  getStylistDetails() {
    try {
      const retrievedUserData = this.storageService.getUserData();
      this.userId = retrievedUserData.sId;
      this.gracePeriod = retrievedUserData.gracePeriod;
      this.subscriptionExpired = retrievedUserData.subscriptionExpired;
      this.subEndDate = retrievedUserData.subscriptionEndDate;
      this.isTrialPeriod = retrievedUserData.trialPeriod;
      this.userFacadeService.getUser(this.userId).subscribe({
        next: (response: any) => {
          this.cancelUseId = response.userId;
        },
        error: (error) => {
        }
      });
    } catch (error: any) {
    }
  }

  close() {
    this.bottomSheet.dismiss();
  }

  confirmDelete() {
    // Open confirmation popup
    const config: MatBottomSheetConfig = {
      hasBackdrop: true, // Enable backdrop
    };

    const bottomSheetRef: MatBottomSheetRef = this.bottom.open(
      DeleteAccountComponent,
      {
        panelClass: 'custom-style',
        data: {
          value: 'confirmDelete',
          deleteOption: this.deleteOption,
        },
        ...config,
      }
    );

    bottomSheetRef.afterOpened().subscribe(() => {
      // Listen for backdrop click event and close the bottom sheet
      const backdrop = document.querySelector('.cdk-overlay-backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', () => {
          bottomSheetRef.dismiss();
        });
      }
    });
  }

  delete(){
    const requestBody = {
      id: this.cancelUseId,
      isImmediateDelete: this.deleteOption == 'immediate' ? true : false,
     //isImmediateDelete: true,
      //isDeleted: true,
      updatedBy: this.cancelUseId,
    };
    this.userFacadeService.deleteUserAccount(requestBody).subscribe({
      next: (response) => {
        if(response == 'Success'){
        
          this.bottom.dismiss();  // if you're inside a BottomSheetRef context
          this.storageService.clearAuthSession(); 
          this.router.navigate(['auth/login']); // Or wherever you want to go
          this.snackBar.successSnackbar('Account deleted Successfully');
        } else{
          this.snackBar.errorSnackbar('something went wrong');
        }   
    },
  error: (error) => {
    console.error('Error deleting user:', error);
    // Show error UI
  }
  });
  } 

  radioSelected(event: any) {
    this.deleteOption = event.value;
  }

}
